<div
  #card
  class="card"
  [ngClass]="{
    'card-locked-height': global
  }"
>
  @if (entity) {
    <div class="card-header">
      <div class="home-entity">
        <div class="home-entity-title" [ngClass]="{ 'home-entity-title-center': global }">
          {{ entity.entity }}
        </div>
        <div class="home-entity-total">
          <span>
            {{ formatNumber(entity.devicesTotal, numberFormat) }}
          </span>
          <span>{{ "devices" | translate }}</span>
        </div>
        <div class="home-alarms-data">
          <span>{{ "active-alarms" | translate }}</span>
          <span>
            {{ entity.totalAlarms ? formatNumber(entity.totalAlarms, numberFormat) : "-" }}
          </span>
        </div>
      </div>
    </div>
    <div class="card-body">
      <!-- Alarms cloud chart -->
      @if (entity.alarmCodeList?.length > 0) {
        <div class="home-alarms">
          <div class="home-cards-title">
            <i class="fas fa-triangle-exclamation"></i>
          </div>

          <!-- Alarms cloud chart -->
          @if (entity.alarmCodeList?.length > 0 && entity.alarmsCloudChartOptions) {
            <app-graph-controller
              [highchartsOptions]="alarmsCloudHighchartsOptions"
              [noOptionsParse]="true"
              [onlyGraph]="true"
              [disableShowPoints]="true"
              [data]="entity.alarmsCloudChartOptions"
            ></app-graph-controller>
          } @else {
            <span>{{ "no-alarms" | translate }}</span>
          }
        </div>
      }

      <!-- Totals chart -->
      @if (deviceTotalsHighchartsOptions) {
        <div class="home-totals">
          <div class="home-cards-title">
            <i class="fas fa-circle-nodes"></i>
          </div>
          @if (entity.devicesTotal > 0) {
            <app-graph-controller
              [highchartsOptions]="deviceTotalsHighchartsOptions"
              [noOptionsParse]="true"
              [onlyGraph]="true"
              [disableShowPoints]="true"
              [data]="entity.deviceTotalsChartOptions"
            ></app-graph-controller>
            <div class="home-total-graph-legend">
              <!-- In network -->
              @if (entity.totalInNetwork > 0) {
                <div class="home-graph-data-label">
                  {{ "in-network" | translate }}
                  <span class="home-graph-total-percent">
                    {{
                      formatNumber(
                        (
                          (entity.totalInNetwork /
                            (entity.devicesTotal -
                              entity.devicesCountByType.externalWithoutCom.noCom -
                              entity.devicesCountByType.walkBy.total)) *
                          100
                        ).toFixed(2),
                        numberFormat
                      )
                    }}%
                  </span>
                  <span class="home-graph-total greenIcon">
                    {{ formatNumber(entity.totalInNetwork, numberFormat) }}
                  </span>
                </div>
              }
              <!-- No communication -->
              @if (entity.totalNoCommunication > 0) {
                <div class="home-graph-data-label pointer">
                  {{ "no-communicates" | translate }}
                  <span class="home-graph-total-percent">
                    {{
                      formatNumber(
                        (
                          (entity.totalNoCommunication /
                            (entity.devicesTotal -
                              entity.devicesCountByType.externalWithoutCom.noCom -
                              entity.devicesCountByType.walkBy.total)) *
                          100
                        ).toFixed(2),
                        numberFormat
                      )
                    }}%
                  </span>
                  <span class="home-graph-total grayDarkIcon">
                    {{ formatNumber(entity.totalNoCommunication, numberFormat) }}
                  </span>
                </div>
              }
              <!-- Pending -->
              @if (entity.totalPending > 0) {
                <div class="home-graph-data-label pointer">
                  {{ "pending" | translate }}
                  <span class="home-graph-total-percent">
                    {{
                      formatNumber(
                        (
                          (entity.totalPending /
                            (entity.devicesTotal -
                              entity.devicesCountByType.externalWithoutCom.noCom -
                              entity.devicesCountByType.walkBy.total)) *
                          100
                        ).toFixed(2),
                        numberFormat
                      )
                    }}%
                  </span>
                  <span class="home-graph-total purpleIcon">
                    {{ formatNumber(entity.totalPending, numberFormat) }}
                  </span>
                </div>
              }
            </div>
          } @else {
            <span>{{ "gateway-no-data" | translate }}</span>
          }
        </div>
      }
      <!-- Network -->
      @if (entity.networkChartOptions?.length > 0) {
        <div class="home-graphs-network">
          <div class="home-cards-title">
            <i class="fas fa-satellite-dish"></i>
          </div>
          @for (device of entity.networkChartOptions; track device) {
            <div class="home-device-graph">
              @if (networkHighchartsOptions) {
                <app-graph-controller
                  [highchartsOptions]="networkHighchartsOptions"
                  [noOptionsParse]="true"
                  [onlyGraph]="true"
                  [disableShowPoints]="true"
                  [data]="device"
                ></app-graph-controller>
              }
            </div>
          }
        </div>
      }
      <!-- Devices -->
      @if (entity.devicesChartOptions?.length > 0) {
        <div class="home-graphs">
          <div class="home-cards-title">
            <i class="fas fa-tachometer-alt"></i>
          </div>
          @for (device of entity.devicesChartOptions; track device) {
            <div class="home-device-graph">
              @if (deviceTypeHighchartsOptions) {
                <app-graph-controller
                  [highchartsOptions]="deviceTypeHighchartsOptions"
                  [noOptionsParse]="true"
                  [onlyGraph]="true"
                  [disableShowPoints]="true"
                  [data]="device"
                ></app-graph-controller>
              }
            </div>
          }
        </div>
      }
    </div>
  } @else {
    <ng-template [ngTemplateOutlet]="elseBlock"></ng-template>
  }
</div>
